import { Product } from './Product'
import { SKU } from './SKU'
import { VoucherSKUValue } from './VoucherSKUValue'

export class Voucher extends Product {
    public skuValues: VoucherSKUValue[] = []

    constructor(
        id: string,
        displayName: string,
        description: string | null,
        public imageId: string | null,
        public policy: string | null,
        public expiryMonths: number | null,
        public expiryDate: Date | null,
        public postalDeliveryFee: number | null,
        skus: SKU[],
        skuValues: VoucherSKUValue[] = [],
        dateCreated: Date,
        dateUpdated: Date
    ) {
        super(id, displayName, description, skus, dateCreated, dateUpdated)
        this.skuValues = skuValues
    }

    hasSKUsOnSale(): boolean {
        return this.skus.some(sku => sku.onSale)
    }

    hasAnySkuValues(): boolean {
        return this.skuValues.length > 0
    }

    get postalDeliveryEnabled(): boolean {
        return this.postalDeliveryFee !== null
    }

    getSKUWithId(skuId: string): SKU | null {
        return this.skus.find(sku => sku.id === skuId) || null
    }

    getValueForSKU(skuId: string): VoucherSKUValue | null {
        return this.skuValues.find(override => override.skuId === skuId) || null
    }

    hasSKUValue(skuId: string): boolean {
        return this.getValueForSKU(skuId) !== null
    }

    getAmountForSKU(skuId: string): number | null {
        const sku = this.getSKUWithId(skuId)
        if (!sku) {
            return 0
        }
        const override = this.getValueForSKU(skuId)
        return override ? override.amount : sku.price
    }

    removeImage() {
        this.imageId = null
    }
}
